div#checkbox-content {
  padding: calc(4 * var(--spacer)) 0 0;
}

gz-checkbox {
  width: auto;
}
